// global-actioncall.js                                            ~/js/swipers
///////////////////////////////////////////////////////////////////////////

import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

// Global - Actioncall Swiper
export const ActioncallSwiper = new Swiper('.actioncall-swiper', {
  modules: [Navigation],
  slidesPerView: 'auto',
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  autoplay: false,
});
